import { useTranslation } from "react-i18next";
import { useLocation, useNavigate } from "react-router-dom";
import { BackButton } from "@/components/ui/back-button";

interface LocationState {
  fromMenu?: boolean;
}

const Proof = () => {
  const { t } = useTranslation();

  const navigate = useNavigate();
  const location = useLocation();
  const state = location.state as LocationState | null;
  const showBackButton = state?.fromMenu === true;

  return (
    <div className="min-h-screen bg-background">
      {showBackButton && (
        <div className="fixed top-4 left-4 z-50">
          <BackButton onClick={() => navigate(-1)} />
        </div>
      )}
      <iframe
        src="/proof/index.html"
        className="w-full h-screen"
        style={{ border: 'none' }}
        title={t('accessibility.labels.nutrition5k_evaluation_results')}
      />
    </div>
  );
};

export default Proof;
